import getEnv from '@providers/getEnv'

import getFileURL from './getFileURL'

export default function getFileCDNUrl(file) {
  if (!file) return
  const S3Url = getFileURL(file)

  if (getEnv() === 'prod') {
    return S3Url.replace('https://s3.amazonaws.com/orioneat-files', 'https://tofuu.getjusto.com')
  }

  return S3Url
}
